'use strict';

var processInclude = require('./util');
var _throttle = require('lodash/throttle');
var stickyScrolling = false;
var _stickyExpanded = false;
var _scrollDirection = null;
var _userTouching = false;
var _scrollAnimation = false;

var initPaypalButton = require('/cartridges/custom_paypal/cartridge/client/default/js/pdp/initPdpButton');
if (document.querySelector('.js_paypal-content')) {
    const paypalUrls = document.querySelector('.js_paypal-content').getAttribute('data-paypal-urls');
    window.paypalUrls = JSON.parse(paypalUrls);
}
/* detect if device is iOS for disable paypal Button in pdp */
function isSafariBrowser() {
    var safari = false;
    var ua = navigator.userAgent.toLowerCase();
    if (ua.indexOf('safari') !== -1) {
        if (ua.indexOf('chrome') > -1) {
            safari = false;
        } else {
            safari = true;
        }
    }
    return safari;
}
const getMobileOS = () => {
    const ua = navigator.userAgent;
    if (/android/i.test(ua)) {
        return 'Android';
    } else if (/iPad|iPhone|iPod/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) {
        return 'iOS';
    }
    return 'Other';
};

/**
 * Injects SDK into page for cart/minicart
*/
function injectPaypalSDK() {
    var head = document.getElementsByTagName('head').item(0);
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.onload = function () {
        initPaypalButton.default();
    };
    script.src = window.paypalUrls.cartSdkUrl;
    script.setAttribute('data-partner-attribution-id', window.paypalUrls.partnerAttributionId);
    head.appendChild(script);
}
function injectAjaxPaypalSDK(cartSdkUrl, partnerAttributionId) {
    var head = document.getElementsByTagName('head').item(0);
    var script = document.createElement('script');
    script.async = true;
    script.type = 'text/javascript';
    script.onload = function () {
        initPaypalButton.default();
    };
    script.src = cartSdkUrl;
    script.setAttribute('data-partner-attribution-id', partnerAttributionId);
    head.appendChild(script);
}

function liveChatPositionStikyDownNewPDP() {
    $('.helpButton, #embeddedMessagingConversationButton').css({
        bottom: '16px',
        top: '',
        right: '16px'
    });
    if ($('.cc-pd.cc-pd-cta-anchored').length > 0) {
        $('.helpButton, #embeddedMessagingConversationButton').css({
            bottom: '60px',
            top: ''
        });
    }
};

function liveChatPositionStikyUpNewPDP() {
    var stikyHeight = $('.cc-pdp__info').height();
    if (window.isMobile) {
        $('.helpButton, #embeddedMessagingConversationButton').css({
            bottom: '192px',
            top: '',
            right: '16px'
        });
    } else if (window.isTablet) {
        $('.helpButton, #embeddedMessagingConversationButton').css({
            bottom: stikyHeight + 46,
            top: '',
            right: '30px'
        });
    } else {
        $('.helpButton, #embeddedMessagingConversationButton').css({
            bottom: stikyHeight + 46,
            top: '',
            right: '30px'
        });
    }
};

function stickyUp (scrolling) {
    stickyScrolling = true;
    var stickyPos = $(document).find('.cc-pdp__info').offset().top;
    $('body').trigger('headerSticky', {sticky: true});  
    $(document).find('.cc-pdp__info').addClass('cc-pdp__info--top');
    $('html, body').css('overscroll-behavior', 'contain');
    let headerHeight = $(document).find('header.js-header.cc-header-sticky').outerHeight(); 
    var finalPosition = stickyPos - headerHeight;
    $('.cc-pdp__wrp').css({ 'margin-top': -finalPosition + 'px' });
    setTimeout(() => {
        $('body').removeClass('cc-pdp-images-blocked');
        _scrollAnimation = false;
    }, 500);
    _stickyExpanded = true;
    stickyScrolling = false;
    // close open modals
    $('.cc-pdp__stickymobile .js-sticky-choice.cc-open').trigger('click');
    liveChatPositionStikyDownNewPDP();

    // analytics
    var pid = $('.product-detail').data('pid');
    $('body').trigger('analytics:dataLayerPushObj', {
        'event': 'custom_event',
        'eventCategory': 'Product Detail Box',
        'eventAction': 'open',
        'eventLabel': pid
    });

    return finalPosition;
}

function stickyCollapse () {
    _scrollDirection = null;
    $('.cc-pdp__wrp').css({ 'margin-top': '' });
    $('.cc-pdp__info').removeClass('cc-pdp__info--top');
    setTimeout(() => {
        $('body').addClass('cc-pdp-images-blocked');
        $('body').css('overscroll-behavior', '');
        $('body').trigger('headerSticky', {sticky: false}); 
        $(document).scrollTop(0);
    }, 500);
    // hide resume if showing
    $('.cc-pdp__resume-mobile').removeClass('cc-pdp__resume-mobile--fixed');
    $('.cc-pdp__content-title').css('margin-top', '');

    // close open modals
    $('.cc-pdp__stickymobile .js-sticky-choice.cc-open').trigger('click');
    liveChatPositionStikyUpNewPDP();

    if (_stickyExpanded) {
        // analytics
        var pid = $('.product-detail').data('pid');
        $('body').trigger('analytics:dataLayerPushObj', {
            'event': 'custom_event',
            'eventCategory': 'Product Detail Box',
            'eventAction': 'close',
            'eventLabel': pid
        });
    }
    _stickyExpanded = false;
}

function imageListHeight () {
    let headerHeight = $('header.js-header').outerHeight();
    let stickyHeight = $('.cc-pdp__info__btn-top').outerHeight() + $('.cc-pdp__info__focus').outerHeight();
    let viewportHeight = window.innerHeight;
    var imageListHeight = viewportHeight - stickyHeight - headerHeight + 10;
    $('.cc-pdp__images .cc-pdp__image-list').css('height', imageListHeight + 'px');
}

function setFocusOnFirstRelatives(){
    $(document).find('.js-pdp-variant-link.cc-standard-image').first().focus();
}


function makeAccessible(isOnLoading, element){
    
    // Customize the aria-label on the sticky banner. On page load, get the active varion and set the appropriate aria-label
    // On varion click (else), get the clicked element information and update the aria-label on the sticky banner button

    var selectedColorInSticky = $('.cc-content-thumb-color-sticky');
    if (isOnLoading){
        var selectedColor = $('.js-color-choice.cc-color-choice.cc-active');
        var accessibilityColorName = selectedColor.data('accessibility-value');
        var accessibilityColorValue = selectedColor.data('attr-value');
        var oldAriaLabel = selectedColorInSticky.attr('aria-label');
        var newAccessibleAriaLabel = oldAriaLabel + " " + accessibilityColorName + " " + accessibilityColorValue;
    } else {
        var accessibilityColorName = element.data('accessibility-value');
        var accessibilityColorValue = element.data('attr-value');
        var defaultAriaLabel = selectedColorInSticky.data('accessibility-value');
        var newAccessibleAriaLabel = defaultAriaLabel + " " + accessibilityColorName + " " + accessibilityColorValue;
    }
    
    selectedColorInSticky.attr('aria-label', newAccessibleAriaLabel);
}

$(document).ready(function () {
    processInclude(require('./components/clientSideValidation'));
    processInclude(require('./product/detailNew'));
    processInclude(require('./product/wishlist'));
    processInclude(require('./product/contactPdp'));
    processInclude(require('./components/socialList'));
    if (window.isMobile) {
        // when reloading, do not use previous scroll position. Always start from the top.
        window.history.scrollRestoration = 'manual';
        window.addEventListener('beforeunload', () => window.scrollTo(0, 0));

        // block scrolling - prevent using cc-blocked also managed by zoom and modals that could broke the usability
        $('body').addClass('cc-pdp-images-blocked');
        // set heigth image list
        /* N.B: it is necessary to set setTimeout(imageListHeight, 750); if the Christmas shipment banner is reactivated on the (PDP). */
        imageListHeight();
    }

    // On page load, change the aria-label of the sticky to the selected color
    makeAccessible(true, null);

    // Everytime the users clicks a variation, update che aria-label of the sticky button
    $(".js-make-accessible").on("click", function() {
        makeAccessible(false, $(this));
    });

    $(".cc-pdp__accordion__btn").on("keypress", function(event) {
        if (event.key === "Enter") {
          // $(this) is the h2 tag
          const targetId = $(this).attr("aria-controls"); 
          const ariaExpandedValue = $(this).attr("aria-expanded");
          
          // targetElement is the div under the h2
          const targetElement = document.getElementById(targetId); 

          if(ariaExpandedValue === "true"){
            $(this).attr('aria-expanded', "false");
            $(this).addClass("collapsed");
            targetElement.classList.remove('show');
            targetElement.classList.add('collapse');
          } else {
            $(this).attr('aria-expanded', "true");
            $(this).toggleClass("collapsed");
            targetElement.classList.add('show');
            targetElement.classList.remove('collapse');
          }
        }
    });

    // Using Tab or Shift+Tab on SHIPPING AND RETURN section 
    $(".js-shipment").on("keydown", function(e) {
        if (e.key === "Enter") {
            
            const ariaExpandedValue = $(this).attr("aria-expanded");
            if(ariaExpandedValue === "true"){
                var elementsWithClass = $('.js-handle-tabindex');
                elementsWithClass.each(function(index, element) {
                    $(element).attr('tabindex', '-1');
                });
            } else {
                var elementsWithClass = $('.js-handle-tabindex');
                elementsWithClass.each(function(index, element) {
                    $(element).attr('tabindex', '0');
                });
            }
        } else {
            if ($(window).width() >= 768) {
                e.preventDefault();
                // Set focus on PACKAGING <h2> using Shift+Tab
                if (e.shiftKey && e.key === 'Tab') {
                    $('[data-target="#pdpAccordion4"]').focus();
                } else if (e.key === 'Tab') {
                    // 1. Check if the section "SHIPPING AND RETURNS" is not expanded.
                    var ariaExpanded = $(this).attr('aria-expanded');
                    if (ariaExpanded === 'true') {
                        // If true, set focus on the first js-handle-tabindex
                        $('.js-handle-tabindex').first().focus();
                    } else {
                        // If closed, check if the sticky banner is visible
                        if ($('.cc-sticky-add-to-cart.cc-open').length > 0) {
                            $(document).find('.cc-content-thumb-color-sticky').focus(); // Set focus on Color
                        } else {
                            setFocusOnFirstRelatives();
                        }
                    }
                } 
            }
        } 
    });


    // Apply Javascript only on Desktop and Tablet devices
    if ($(window).width() >= 768) {

        // Handling focus from "RETURN PROCEDURE PAGE" link in "SHIPPING AND RETURNS". 
        $('.js-handle-tabindex:eq(1)').on('keydown', function(e) {
            if (e.shiftKey && e.key === 'Tab'){
                e.preventDefault();
                $(document).find('.js-handle-tabindex:eq(0)').focus(); // Set focus on Size
            } else if (e.key === 'Tab') {
                e.preventDefault();
                if ($('.cc-sticky-add-to-cart.cc-clearfix.js-sticky-add-to-cart.cc-open').length > 0) {
                    $(document).find('.cc-content-thumb-color-sticky').focus(); // Set focus on Color
                } else {
                    setFocusOnFirstRelatives();
                }
            }
        });
        
        // If "Color" on focus and pressing Shift+Tab, return on SHIPPING AND RETURN <h2>
        $(".cc-content-thumb-color-sticky").on("keydown, click", function(e) {
            if (e.shiftKey && e.key === 'Tab') {
                e.preventDefault();
                $('[aria-controls="pdpAccordion6"]').focus();
            }
        });

        // Handling ADD TO CART focus on Sticky Banner
        $('.js-change-focus-add-to-cart').on("keydown", function(e) {
            if (e.shiftKey && e.key === 'Tab'){
                e.preventDefault();
                $(document).find('.cc-size-choice-button-sticky').focus(); // Set focus on Size
            } else if (e.key === 'Tab') {
                e.preventDefault();
                setFocusOnFirstRelatives();
            }
        });
    }


    
    // da aggiungere controllo su esistenza paypal
    var isIos = getMobileOS() === 'iOS';
    if (! isIos && (! isSafariBrowser() || window.isDesktop)) {
        var addToCartHeigth = $(document).find('.cc-addtocart-buttons .cc-pdp-add-button').height();
        if ($(document).find('.js-checkpaypal-enable').data('ppdisable') && window.paypal) {
            injectPaypalSDK();
            // resolve extraspace
            $(document).find('.cc-content-addtocart .paypal_pdp_button').css('height', addToCartHeigth + 'px');
            $('.js-paypal-fake').parents('.cc-content-button').removeClass('d-none');
        } else {
            var url = $(document).find('.js-checkpaypal-enable').data('urlgetpaypal');
            $.ajax({
                url: url,
                method: 'GET',
                success: function (data) {
                    if (data.isPdpButtonEnabled) {
                        injectAjaxPaypalSDK(data.cartSdkUrl, data.partnerAttributionId);
                        // resolve extraspace
                        $(document).find('.cc-content-addtocart .paypal_pdp_button').css('height', addToCartHeigth + 'px');
                        $('.js-paypal-fake').parents('.cc-content-button').removeClass('d-none');
                    }
                }
            });
        }
    }

    // fix applepay button
    if ($('.cc-apple-pay-pdp').is(':visible')) {
        $('.js-applepay-fake').parents('.cc-content-button').removeClass('d-none');
        if (! window.isDesktop) {
            $('.cc-pdp__add-to-cart .paypal_pdp_button').addClass('d-none');
        }
    }

    // initialize colors slider
    if ($('.cc-pdp .cc-content-colors-choice-sticky .cc-slider').length > 0) {
        if ($('.cc-pdp .cc-content-colors-choice-sticky .cc-slider .slick-slide').length === 0) {
            $('.cc-pdp .cc-content-colors-choice-sticky .cc-slider').each(function () {
                var slidesContainer = $(this);

                slidesContainer.slick({
                    infinite: false,
                    autoplay: false,
                    focusOnSelect: true,
                    centerMode: false,
                    autoplaySpeed: 3000,
                    speed: 500,
                    slidesToScroll: 1,
                    slidesToShow: 5,
                    variableWidth: false,
                    dots: false,
                    arrow: true,
                    prevArrow: '<button class="cc-slider-prev"><div class="cc-svg cc-svg-slider-prev"><span> < </span></div></button>',
                    nextArrow: '<button class="cc-slider-next"><div class="cc-svg cc-svg-slider-next"><span> > </span></div></button>',
                    responsive: [
                        {
                            breakpoint: 1199.98,
                            settings: {
                                slidesToShow: 12
                            }
                        },
                        {
                            breakpoint: 767.98,
                            settings: {
                                slidesToShow: 5
                            }
                        }
                    ]
                });
            });
        }
    };
    if (!window.isMobile) {
        $(document).find('.js-remove-sticky').remove();
    }
    if (window.isMobile) {
        // keep track of scrolling direction
        $(document).on('touchstart', function (eventStart) {
            var startY = eventStart.touches[0].clientY;
            $(document).on('touchmove', _throttle(function (eventMove) {
                _userTouching = true;
                var moveY = eventMove.touches[0].clientY;
                if (moveY < startY) _scrollDirection = 'down';
                else if (moveY > startY) _scrollDirection = 'up';
                else _scrollDirection = null;
                startY = moveY;
                // _scrollDirection = moveY < startY ? 'down' : 'up';
            }, 100, { trailing: false, leading: true }));

            $(document).one('touchend', function() {
                _userTouching = false;
            });
        });

        // dont scroll sticky when scrolling size selector
        $(document).on('touchmove', '.js-selectSize', function(e) {
            e.stopPropagation();
            if (_stickyExpanded) {
                document.body.style.overflow = 'hidden';
                $('.cc-pdp__stickymobile').data('touched', true);
            }
        });

        $(document).on('click', '.cc-pdp__info__btn-top', function(e) {
            e.stopImmediatePropagation();
            if (!$('.cc-pdp__info').hasClass('cc-pdp__info--top')) {
                $('.cc-pdp__info__btn-top').attr('aria-expanded', 'true');
                stickyUp(false);
            } else {
                $('.cc-pdp__info__btn-top').attr('aria-expanded', 'false');
                stickyCollapse();
            }
        });

        // scroll event on last image
        $(document).on('touchmove', '.js-image-list', _throttle(function () {
            if (_scrollAnimation || _scrollDirection !== 'down') return;
            var imageListHeight = $(document).find('.js-image-list')[0].offsetHeight;
            var imageListScrollTop = $(document).find('.js-image-list')[0].scrollTop;
            var imageListScrollHeight = $(document).find('.js-image-list')[0].scrollHeight;
            if (imageListHeight + imageListScrollTop >= imageListScrollHeight -1) {
                _scrollAnimation = true;
                stickyUp(false);
            }
        }, 100));

        // disable touch events when overscrolling (safari < 16.0)
        $(document).on('scroll', function (){
            if (! _stickyExpanded) return;
            if (document.documentElement.scrollTop < 0) document.body.style.touchAction = 'none';
            else document.body.style.touchAction = '';
        });

        // collapse sticky when over-scrolling the sticky upwards
        $(document).on('touchstart', function(e) {
            if (_stickyExpanded) {
                if (document.documentElement.scrollTop < 10) {
                    $('.cc-pdp__content-title').css('margin-top', '25px');
                    document.documentElement.scrollTo(0, 10);
                    $('.cc-pdp__stickymobile').data('touched', true);
                }

                $(document).on('touchmove.from-sticky-to-imgs', function() {
                    if (_userTouching && _scrollDirection === 'up' && document.documentElement.scrollTop < 30) {
                        document.body.style.overflow = 'hidden';
                        document.body.style.touchAction = 'none';
                        stickyCollapse();
                    }
                });

                // disable on touchend
                $(document).one('touchend', ()=> {
                    $(document).off('touchmove.from-sticky-to-imgs');
                    document.body.style.overflow = '';
                    document.body.style.touchAction = '';
                    setTimeout(() => {
                        $('.cc-pdp__stickymobile').removeData('touched');
                    }, 1000);
                });
            }
        });

        // scroll down on minimized sticky
        $(document).on('touchmove', '.cc-pdp__info:not(.cc-pdp__info--top)', _throttle(function() {
            if (_scrollDirection === 'down' && !_scrollAnimation && !_stickyExpanded) {
                _scrollAnimation = true;
                stickyUp(false);
            }
        }, 100));

        // fix sticky when scrolling down
        var header = $('.js-header')[0];
        var sticky = $('.cc-pdp__info')[0];
        var stickyButtonHeight = $('.cc-pdp__info__btn-top').height();
        var stickyAddToCart = $('.cc-pdp__add-to-cart')[0];
        var resume = $('.cc-pdp__resume-mobile')[0];
        var resumeHeight = $(resume).height();
        liveChatPositionStikyUpNewPDP();

        $(document).on('scroll', _throttle(function (e) {
            var headerHeight = header.offsetHeight;
            var stickyTop = sticky.getBoundingClientRect().top;

            if (_stickyExpanded && stickyTop > header.offsetHeight) {
                // scrolling up to the images from sticky expanded
                // $(sticky).removeClass('cc-pdp__info--top');
                // hide resume if showing
                $(resume).removeClass('cc-pdp__resume-mobile--fixed');
                // _stickyExpanded = false;
            } else if (_stickyExpanded) {
                // hide or show resume
                var stickyAddToCartBottom = stickyAddToCart.getBoundingClientRect().bottom;

                if (_scrollDirection === 'down') {
                    // show resume
                    if (stickyAddToCartBottom <= headerHeight + stickyButtonHeight) {
                        $(resume).addClass('cc-pdp__resume-mobile--fixed');
                    }
                } else if (_scrollDirection === 'up') {
                    // hide resume
                    if (stickyAddToCartBottom >= headerHeight + stickyButtonHeight + resumeHeight) {
                        $(resume).removeClass('cc-pdp__resume-mobile--fixed');
                    }
                }
            }
        }, 50));

        $(document).on('click', '.js-newpdp-resume-addtocart, .js-paypal-fake, .js-applepay-fake', function(e) {
            var accessType = 'sticky-bar-top-micro';
            var buttonType;
            if ($(this).is('.js-paypal-fake'))  buttonType = 'paypal';
            else if ($(this).is('.js-applepay-fake')) buttonType = 'applepay';
            $('#size-modal-sticky,#size-overlay').data('analyticsowner', buttonType);
            var $addToCartButton = $('.cc-pdp__add-to-cart .add-to-cart');
            if ($addToCartButton.data('disabled')) {
                _scrollDirection = null;
                // var finalPosition = stickyUp(false);
                var finalPosition = 0;
                $(document).scrollTop(finalPosition);
                $('.cc-pdp__resume-mobile').removeClass('cc-pdp__resume-mobile--fixed');
                var lastPosition = $(document).scrollTop();
                var interval = setInterval(() => {
                    var currentPosition = $(document).scrollTop();
                    if (currentPosition === finalPosition || currentPosition === lastPosition) {
                        clearInterval(interval);
                        // open size selector
                        setTimeout(() => {
                            if ($(this).is('.js-newpdp-resume-addtocart')) {
                                $addToCartButton.trigger('click', {accessType});
                            } else {
                                $('.cc-pdp__stickymobile .js-sticky-choice').trigger('click', {accessType});
                            }
                        }, 100);
                    } else {
                        lastPosition = $(document).scrollTop();
                    }
                }, 100);
            } else {
                // size already selected
                if ($(this).hasClass('js-newpdp-resume-addtocart')) {
                    $addToCartButton.addClass('js-went-micro-button');
                }
                $addToCartButton.trigger('click', {accessType});
            }
        });

        $('body').on('product:afterAttributeSelect', function () {
            var $addToCartButton = $('.cc-pdp__add-to-cart .add-to-cart');
           if ($addToCartButton.data('disabled')) {
               $('.cc-pdp__resume-mobile').find('.js-paypal-fake, .js-applepay-fake').css('pointer-events', 'auto');
               $('.cc-pdp__resume-mobile').find('.cc-paypal-hidden, .cc-applepay-hidden').addClass('d-none');
           } else {
               $('.cc-pdp__resume-mobile').find('.js-paypal-fake, .js-applepay-fake').css('pointer-events', 'none');
               $('.cc-pdp__resume-mobile').find('.cc-paypal-hidden, .cc-applepay-hidden').removeClass('d-none');
           }
       });
    }
});
